/**
 * Dynamically adds the ReCAPTCHA script. This is done once per page, regardless of the number of forms on a page.
 * 
 * @param formDiv The HTML Element that contains the form container that contains the data-leadform-id element.
 * @param formId Gravity Forms ID
 */
export const registerRecaptcha = (formDiv : Element, formId : string | number) => {
  const loaded = isRecaptchaScriptLoaded();
  if(loaded) {
    console.log('The reCAPTCHA script is already loaded on the page.');
    return;
  }
  
  const siteKey = getRecaptchaSiteKey(formDiv);
  
  // Append the script element to the head section
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  script.async = true;
  document.head.appendChild(script);
}

/**
 * Retrieve the ReCAPTCHA Site Key that is added as a data attribute on a form field.
 * 
 * @param formDiv The HTML Element that contains the form container that contains the data-leadform-id element.
 * @returns The site key provided by the API.
 */
export const getRecaptchaSiteKey = (formDiv : Element) : string => {
  const container = formDiv.querySelector('.ginput_recaptcha');
  const siteKey = container?.getAttribute('data-sitekey');

  return siteKey ?? '';
}

/**
 * Retrieves the field name of the ReCAPTCHA field that is added as a data attribute on a form field.
 * 
 * @param formDiv The HTML Element that contains the form container that contains the data-leadform-id element.
 * @returns The field Name
 */
export const getRecaptchaFieldName = (formDiv : Element) : string => {
  const container = formDiv.querySelector('.ginput_recaptcha');
  const fieldName = container?.getAttribute('data-field-name');

  return fieldName ?? '';
}

/**
 * Confirms if the reCAPTCHA script is already loaded on the page.
 */
const isRecaptchaScriptLoaded = () : boolean => {
  var scriptTags = document.getElementsByTagName('script');

  for (var i = 0; i < scriptTags.length; i++) {
    if (scriptTags[i].src.includes('https://www.google.com/recaptcha/api.js')) {
      return true;
    }
  }

  return false;
}